import { get, post, deleteRequest, put, handleErrors } from "./requests";
import { URL_BASE } from "./constants";
import { Store } from "../redux/store";
import { loadCategories } from "../redux/actions/categoryActions";
import { getFormDataFromObject } from "../shared/helpers/formDataHelper";

async function getAllCategories() {
    const url = `${URL_BASE}/categories`;
    const categories = await get(url);
    Store.dispatch(loadCategories(categories.data));
    return categories.data;
}

async function getAllMacrocategories() {
    const url = `${URL_BASE}/categories/onlyMacro`;
    const categories = await get(url);
    return categories.data;
}

async function addCategory(name, description, icon = null, idMacrocategory = null) {
    const category = {
        Name: name,
        Description: description,
        Icon: icon,
        IdMacrocategory: idMacrocategory
    };
    const url = `${URL_BASE}/categories`;
    const data = getFormDataFromObject(category);
    await post(url, data, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllCategories();
}

async function updateCategory(id, name, description, icon = null, idMacrocategory = null) {
    const category = {
        Id: id,
        Name: name,
        Description: description,
        Icon: icon,
        IdMacrocategory: idMacrocategory
    };

    const url = `${URL_BASE}/categories`;
    const data = getFormDataFromObject(category);

    await put(url, data, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllCategories();
}

export async function deleteCategory(id) {
    const url = `${URL_BASE}/categories/${id}`;
    await deleteRequest(url, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllCategories();
}

export default {
    getAllCategories,
    getAllMacrocategories,
    addCategory,
    updateCategory,
    deleteCategory
};